import { GetterTree } from 'vuex'

import { RootState } from '../../types'
import { OrderConfirmState } from './types'

export const getters: GetterTree<OrderConfirmState, RootState> = {
}
